import _ from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getOfficeListReq,
  getOfficeListResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { SessionKeys } from "../../utils/AppUtils";
import { useTranslation } from "react-i18next";
const ChooseAgentStatus = (props) => {

  const { selectedAgentStatus, setSelectedAgentStatus,
    parentName, setTitleHeading } = props;
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const [agentStatusLabel, setAgentStatusLabel] = useState([
    { value: 1, label: t("Active") }, { value: 2, label: t("Inactive") }, { value: 3, label: t("all") },
  ])

  return (
    <>
      <div className="chooseteams chooseppl">
        <div className="chooseteamate d-flex justify-content-between">
          {
            agentStatusLabel.map((aStatus) => {
              return (
                <div className="form-check cursor-pointer">
                  <input
                    className="form-check-input cursor-pointer"
                    type="checkbox"
                    value={aStatus.value}
                    checked={selectedAgentStatus.includes(_.toNumber(aStatus.value))}
                    onChange={(e) => {
                      let agentArr = _.clone(selectedAgentStatus)
                      let changedValue = _.toNumber(e.target.value)
                      console.log(changedValue)
                      console.log(agentArr)
                      if (e.target.checked) {
                        if (changedValue === 3) {
                          agentArr = [1,2,3];
                        } else {
                          agentArr.push(_.toNumber(changedValue))
                          if (agentArr.includes(1) && agentArr.includes(2)) {
                            agentArr = [1,2,3]
                          }
                        }
                      } else {
                        if (changedValue !== 3) {
                          agentArr = _.remove(agentArr, (a) => {
                            return (a !== changedValue && a !== 3)
                          })
                        } else {
                          agentArr = [];
                        }
                      }
                      setSelectedAgentStatus(agentArr)
                    }}
                  />
                  <label
                    className="form-check-label cursor-pointer"
                    for="termofusein"
                  >
                    {aStatus.label}
                  </label>
                </div>
              )
            })
          }
        </div>
      </div>
    </>
  );
};

export default ChooseAgentStatus;
